import React from "react";
// import Helmet from "../component/common/Helmet";
import { Helmet } from "react-helmet";
import HeaderThree from "../component/header/HeaderThree";

import { Row, Col, Card, CardBody } from "reactstrap";
import { useTranslation } from "react-i18next";

const LegalNoticePage = () => {
  const { t, i18n } = useTranslation();
  const icon = `${process.env.PUBLIC_URL}/assets/images/gp_images/ecoshift-logo-brand-eco-movement-ecoresponsible-ecopositive.webp`;

  window.onload = function () {
    // Code runs after full page load
    console.log("Page fully loaded!");
    //const purpose = document.getElementById("purpose");
    //purpose.style.opacity = 0;
    document.querySelector(".header--fixed").classList.add("sticky");
  };

  return (
    <div className="active-dark bg_color--ugs">
      <Helmet>
        <title>Legal notices</title>
        <meta
          name="description"
          content="We accelerate the transition to eco-friendly consumption for everyone's enjoyment."
        />
        <meta
          name="keywords"
          content="ecoshift,shift,impact,transition,eco,friendly,consumption,eco-positive,sustainability,biodiversity,ecoresponsible,nature,onboarding,governance,seat,voice,voting,rights,planet,boundaries"
        />
        <meta property="og:title" content="Nature on the board" />
        <meta
          property="og:description"
          content="We accelerate the transition to eco-friendly consumption for everyone's enjoyment."
        />
        <meta property="og:image" content={icon} />
        <meta property="og:url" content={process.env.PUBLIC_URL + "/"} />
        <meta name="twitter:card" content={icon} />
        <meta name="robots" content="index, follow" />
        <link rel="canonical" href="https://ecoshift.eco/legal-notice" />
      </Helmet>

      <HeaderThree
        homeLink="/"
        logo="symbol-dark"
        color="color-black"
        alwaysSticky="true"
      />

      {/* Start About us Area  */}
      <Card id="nature-on-board" className="card_color--ugs ">
        <CardBody>
          <div className="slider-wrapper">
            <div id="whoweare" className="fix top-inset-main">
              <div className="service-area creative-service-wrapper pb--80 card_color--ugs ">
                <div className="container">
                  <br />
                  <br />
                  <br />

                  <br />

                  <div className="row">
                    <div className="col-lg-8 col-md-8 mr-4">
                      <p className="section-title-left text-color">
                        {t("Legal Notices")}
                      </p>
                      <p className="text-blod-description-18 text-left-important text-color mt-3">
                        {t("EcoShift is a registered trademark")}
                      </p>
                      <br />
                      <p className="text-blod-description-18 text-left-important" dangerouslySetInnerHTML={{ __html: t("Company Name: EcoShift SA") }}/>
                      <p className="text-blod-description-18 text-left-important" dangerouslySetInnerHTML={{ __html: t("Registered Office: Av. W.Churchill 123/8, 1180 Brussels, BE") }}/>
                      <p className="text-blod-description-18 text-left-important" dangerouslySetInnerHTML={{ __html: t("Company Number: BE 1025.416.197") }}/>
                      <p className="text-blod-description-18 text-left-important" dangerouslySetInnerHTML={{ __html: t("Responsible Editor: Baudouin Denis") }}/>
                      <p className="text-blod-description-18 text-left-important" dangerouslySetInnerHTML={{ __html: t("Data Controller: Baudouin Denis") }}/>
                      <p className="text-blod-description-18 text-left-important" dangerouslySetInnerHTML={{ __html: t("Contact: info@ecoshift.eco") }}/>
                      <p className="text-blod-description-18 text-left-important" dangerouslySetInnerHTML={{ __html: t("Host: Infomaniak Network SA") }}/>
                      <p className="text-blod-description-18 text-left-important" dangerouslySetInnerHTML={{ __html: t("Address: Rue Eugène-Marziano 25, 1227 Les Acacias, CH") }}/>
                     
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </CardBody>
      </Card>
      {/* End About us Area  */}
    </div>
  );
};

export default LegalNoticePage;
